export const CUSTOMIZE_CONFIG = {
  name: 'customize',
  label: '自定义配置项',
};

export const CONFIG_MODE = 'configMode';

export const CONFIG_FIELD_INFO = 'configFieldInfo';

export const OVERVIEW_CARDS_EXCLUDES = 'overviewCardsExcludeList';

export const SDK_CONFIG = 'sdkConfig';
